import { Link } from '@wartek-id/link'

import { SatDikDetail } from '@/apis/types'

import { KeyValTable } from '@/components/KeyValTable'

type Props = {
  data?: SatDikDetail
}

const SEKOLAH_DATA_BASE_URL = `https://sekolah.data.kemdikbud.go.id/index.php/Chome/profil`

export function TabIdentitas({ data }: Props) {
  const streetName = data?.alamatJalan || ''
  const withRt = data?.rt ? `, RT: ${data?.rt}` : ''
  const withRw = data?.rt ? ` RW: ${data?.rw}` : ''

  const address = `${streetName}${withRt}${withRw}`
  return (
    <KeyValTable
      classNames={{
        colKey: 'md:min-w-[200px]',
      }}
      rows={[
        {
          key: 'name',
          displayName: 'Nama',
          value: data?.nama || '-',
        },
        {
          key: 'npsn',
          displayName: 'NPSN',
          value: data?.npsn || '',
          CustomValueComponent: ({ value }) => {
            return (
              <Link
                href={`${SEKOLAH_DATA_BASE_URL}/${data?.satuanPendidikanId}?utm_source=portal-satu-data`}
                underline={false}
                rel="noopener noreferrer"
                target="_blank"
              >
                {value}
              </Link>
            )
          },
        },
        {
          key: 'alamat',
          displayName: 'Alamat',
          value: address || '-',
        },
        {
          key: 'kec',
          displayName: 'Kecamatan/Kota (LN)',
          // @ts-ignore
          value: data?.namaKecamatan || '-',
        },
        {
          key: 'kota',
          displayName: 'Kab.Kot/Negara (LN)',
          // @ts-ignore
          value: data?.namaKabupaten || '-',
        },
        {
          key: 'prov',
          displayName: 'Provinsi/Luar Negeri',
          // @ts-ignore
          value: data?.namaProvinsi || '-',
        },
        {
          key: 'status',
          displayName: 'Status Sekolah',
          value: data?.statusSatuanPendidikan || '-',
        },
        {
          key: 'bentuk',
          displayName: 'Bentuk Pendidikan',
          value: data?.bentukPendidikan || '-',
        },
        {
          key: 'jenjang',
          displayName: 'Jenjang Pendidikan',
          value: data?.jenjangPendidikan || '-',
        },
        {
          key: 'jenis',
          displayName: 'Jenis Pendidikan',
          value: data?.jenisPendidikan || '-',
        },
        {
          key: 'program',
          displayName: 'Program Pendidikan',
          value: data?.programPendidikan || '-',
        },
      ]}
    />
  )
}
